import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";

import {
  Container,
  Paper,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TablePagination,
  Radio,
  RadioGroup,
  FormControlLabel
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import API_URL from "./Apiurl";

import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";
import SearchIcon from "@mui/icons-material/Search";

const headCells = [
  { id: "pj_projectname", label: "Project" },
  { id: "vm_vendorname", label: "Vendor" },
  { id: "ts_date", label: "Date" },
  { id: "ts_mode", label: "Mode" }
];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

function stableSort(array, cmp) {
  const stabilized = array.map((el, index) => [el, index]);

  stabilized.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilized.map((el) => el[0]);
}


function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => () => {
    onRequestSort(property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            onClick={createSortHandler(headCell.id)}
            style={{ fontWeight: "bold", cursor: "pointer" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}



class TransactionReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),

      projectId: "",
      vendorId: "",
      vendorType: "1",

      selectedProject: null,
      selectedVendor: null,

      projectarrauto: [],
      vendorarrauto: [],

      reportData: [],

      modearrauto: [],
      selectedMode: null,
      ts_mode: "",
	  
	  order: "asc",
orderBy: "",

      page: 0,
      rowsPerPage: 10,
      totalRecords: 0,

      
    };
  }

  modeMap = {
    1: "Cash",
    2: "Bank Transfer",
    3: "UPI",
    4: "Cheque"
  };

  componentDidMount() {
    this.fetchReport();
  }

  /* ---------------- PROJECT ---------------- */
  onloadProjectBind = async (event) => {
    const res = await axios.get(
      API_URL +
        "ajaxprojects.php?action=getallprojectautoextender&projectname=" +
        event.target.value
    );

    this.setState({
      projectarrauto: (res.data || []).map((r) => ({
        title: r.pj_projectname,
        pj_id: r.pj_id
      }))
    });
  };

  /* ---------------- VENDOR ---------------- */
  onloadVendorBind = async (event) => {
    const res = await axios.get(
      API_URL +
        "ajaxtransactions.php?action=vendortypeautoextender&vm_vendorname=" +
        event.target.value +
        "&vm_type=" +
        this.state.vendorType
    );

    this.setState({
      vendorarrauto: (res.data || []).map((r) => ({
        title: r.vm_vendorname,
        vm_id: r.vm_id
      }))
    });
  };

  /* ---------------- FETCH ---------------- */
  fetchReport = () => {
    axios
      .get(
        API_URL +
          "ajaxtransactions.php?action=getall" +
          "&ts_pj_id=" +
          this.state.projectId +
          "&ts_vm_id=" +
          this.state.vendorId +
          "&ts_mode=" +
          this.state.ts_mode +
          "&fromdate=" +
          this.state.fromDate.format("YYYY-MM-DD") +
          "&todate=" +
          this.state.toDate.format("YYYY-MM-DD") +
          "&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage +
          "&sorting=ts_id desc"
      )
      .then((res) => {
        this.setState({
          reportData: res.data || [],
          totalRecords: res.data?.[0]?.count || 0
        });
      });
  };
  
  handleRequestSort = (property) => {
  const isAsc =
    this.state.orderBy === property && this.state.order === "asc";

  this.setState({
    order: isAsc ? "desc" : "asc",
    orderBy: property
  });
};

  render() {
    return (
     <div className="containermain">
<Paper className="container">
          <div className="boxheading">
<div className="contntpad">
<h2>Transaction Report</h2>
</div>
</div>

          {/* ---------------- SEARCHBOX (NEW FORMAT) ---------------- */}
             <div className="searchmaster">
            <ul>

              <li>
                <p>From Date</p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={this.state.fromDate}
                    onChange={(newValue) => this.setState({ fromDate: newValue })}
          slotProps={{ textField: { size: "small" } }}
                  />
                </LocalizationProvider>
              </li>

              <li>
                <p>To Date</p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={this.state.toDate}
                    onChange={(newValue) => this.setState({ toDate: newValue })}
          slotProps={{ textField: { size: "small" } }}
                  />
                </LocalizationProvider>
              </li>

              <li>
                <p className="stadrp">Project</p>
                <Autocomplete
        options={this.state.projectarrauto}
        value={this.state.selectedProject}
        onChange={this.onProjectChange}
        getOptionLabel={(o) => o.title || ""}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search Project"
            onChange={this.onloadProjectBind}
          />
        )}
      />
              </li>

              <li>
                <p >Vendor Type</p>
                <RadioGroup
                  row
                  value={this.state.vendorType}
                  onChange={(e) =>
                    this.setState({
                      vendorType: e.target.value,
                      vendorId: "",
                      selectedVendor: null,
                      vendorarrauto: []
                    })
                  }
                >
                  <FormControlLabel value="1" control={<Radio />} label="Vendor" />
                  <FormControlLabel value="2" control={<Radio />} label="Mastri" />
                  <FormControlLabel value="3" control={<Radio />} label="Service" />
                </RadioGroup>
              </li>

              <li>
                <p className="stadrp">Vendor</p>
                <Autocomplete
                  options={this.state.vendorarrauto}
                  value={this.state.selectedVendor}
                  onChange={(e, v) =>
                    this.setState({
                      selectedVendor: v,
                      vendorId: v?.vm_id || ""
                    })
                  }
                  getOptionLabel={(o) => o.title || ""}
                  renderInput={(params) => (
                    <TextField {...params} onChange={this.onloadVendorBind} />
                  )}
                />
              </li>

              <li>
                <p className="searchbutton">
        <Button
          variant="contained"
          onClick={this.fetchReport}
          endIcon={<SearchIcon />}
        >
          Search
        </Button>
		</p>
              </li>

            </ul>
          </div>

          {/* ---------------- TABLE ---------------- */}
          <TableContainer sx={{ mt: 3 }}>
            <Table>

              <EnhancedTableHead
  order={this.state.order}
  orderBy={this.state.orderBy}
  onRequestSort={this.handleRequestSort}
/>

              <TableBody>
                {stableSort(
  this.state.reportData,
  getSorting(this.state.order, this.state.orderBy)
).map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>{r.pj_projectname}</TableCell>
                    <TableCell>{r.vm_vendorname}</TableCell>
                    <TableCell>
                      {r.ts_date ? dayjs(r.ts_date).format("DD-MM-YYYY") : ""}
                    </TableCell>
                    <TableCell>{this.modeMap[r.ts_mode] || ""}</TableCell>
                  </TableRow>
                ))}
              </TableBody>

            </Table>

            <TablePagination
              component="div"
              count={this.state.totalRecords}
              page={this.state.page}
              onPageChange={(e, p) =>
                this.setState({ page: p }, this.fetchReport)
              }
              rowsPerPage={this.state.rowsPerPage}
              onRowsPerPageChange={(e) =>
                this.setState(
                  {
                    rowsPerPage: parseInt(e.target.value, 10),
                    page: 0
                  },
                  this.fetchReport
                )
              }
            />
          </TableContainer>

        </Paper>
      </div>
    );
  }
}

export default TransactionReport;